import { defineComponent as _defineComponent } from 'vue'

enum SizePreset {
  H40px = 'H40px',
}

export { OzBaseButtonHrefMode as OzSkewedButtonHrefMode } from 'library/v4/components/OzBaseButton.vue'
export { SizePreset as OzSkewedButtonSizePreset }

import OzBaseButton, { OzBaseButtonHrefMode } from 'library/v4/components/OzBaseButton.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzSkewedButton',
  props: {
    ariaLabel: { default: '' },
    darkMode: { type: [Boolean, String], default: 'auto' },
    dir: { default: 'auto' },
    disabled: { type: Boolean, default: false },
    href: { default: undefined },
    hrefMode: { default: OzBaseButtonHrefMode.Default },
    sizePreset: { default: SizePreset.H40px }
  },
  emits: ["focus", "blur", "mouseenter", "mouseleave", "click"],
  setup(__props: any) {

const props = __props as { ariaLabel: string, darkMode: boolean | 'auto', dir: 'ltr' | 'rtl' | 'auto', disabled: boolean, href: string, hrefMode: OzBaseButtonHrefMode, sizePreset: SizePreset }





const skewAngle = computed(() => {
  switch (props.sizePreset) {
    case SizePreset.H40px:
      return props.dir === 'rtl' ? -10 : 10
    default:
      return 0
  }
})

return { __sfc: true,SizePreset, props, skewAngle, OzBaseButton }
}

})